import { ReferenceItem, ReferenceValue } from '../../../../../../types/types';
import { isEmptyValue } from '../../../../../../utils/managerUtils';

type IsResolvingDisplayedLabelOptions = {
  isResolvingInitialValue: boolean;
  value: ReferenceValue;
  selectedItems: ReferenceItem[];
  isValueLookupLoading: boolean;
}

// Label lookups run on the isolated channel and never set isLoading, so the
// display-only placeholder also needs that channel's own flag.
export const isResolvingDisplayedLabel = ({
  isResolvingInitialValue,
  value,
  selectedItems,
  isValueLookupLoading,
}: IsResolvingDisplayedLabelOptions): boolean =>
  isResolvingInitialValue ||
  (!isEmptyValue(value) && selectedItems.length === 0 && isValueLookupLoading);
